<template>
   <v-card flat>
    <v-card-title>GET - /api/postcodes/{postcode}/addresses</v-card-title>
    <hr />
    <v-card-text>
      <v-simple-table class="table">
        <template v-slot:default>
          <tbody>
            <tr>
              <td>HTTP Method :</td>
              <td>GET</td>
            </tr>
            <tr>
              <td>URL :</td>
              <td>
                <a :href="url + restUrl" target="_blank">{{url +restUrl}}</a>
              </td>
            </tr>
            <tr>
              <td>Description :</td>
              <td>This function allows you to get an address based on the postcode entered. It gives the response based on the request parameters</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>

    <v-card-title>Request Parameters:</v-card-title>
    <v-card-text>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Parameter Name</th>
              <th class="text-left">Description</th>
              <th class="text-left">Parameter Type</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>postcode</td>
              <td>Postcode value to get address</td>
              <td>path</td>
            </tr>
            <tr>
              <td>isPartialLookup</td>
              <td>true/false</td>
              <td>query</td>
            </tr>
            <tr>
              <td>serialized</td>
              <td>true/false</td>
              <td>query</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>

    <v-card-title>Postcode:</v-card-title>
    <v-card-text>
      <ul v-for="(postcodelist,i) in postcodeLists" :key="i">
        <li v-text="postcodelist.text"></li>
      </ul>
    </v-card-text>

    <v-card-title>isPartialLookup:</v-card-title>
    <v-card-text>
      <ul>
        <li>By default value of “isPartialLookup” is false</li>
      </ul>
    </v-card-text>

    <v-card-title>serialized:</v-card-title>
    <v-card-text>
      <ul>
        <li>By default value of “serialised” is true. Refer below JSON response when “serialized” parameter value is true.</li>
      </ul>
    </v-card-text>

    <v-card-title>JSON Request:</v-card-title>
    <v-card-text>
      <pre>
      <code>[
        "OrganisationName"|"DepartmentName"|"PoBoxNumber"|"SubBuilding"|
        "Building"|"DependentThoroughfare"|"Thoroughfare"|
        "DoubleDependentLocality"|"DependentLocality"|"PostTown"|"Postcode"
        ]</code>
      </pre>
    </v-card-text>
    <v-card-text>
      <ul v-for="(otherList,i) in otherLists" :key="i">
        <li v-text="otherList.text"></li>
      </ul>
    </v-card-text>

    <v-card-title>JSON Response:</v-card-title>
    <v-card-text>
      <pre>
      <code v-html="jsonResponse" />
      </pre>
    </v-card-text>
    <br/>
  </v-card>
</template>

<script>
export default {
  name: "adddressapi",

  data: () => ({
    url: process.env.VUE_APP_BASE_URL,
    restUrl: "postcodes/{postcode}/addresses",
    jsonResponse:
     [
      {
        OrganisationName: "APPNOVATION TECHNOLOGIES LTD",
        DepartmentName: "",
        PoBoxNumber: "",
        SubBuilding: "",
        Building: "READING BRIDGE HOUSE",
        DependentThoroughfare: "",
        Thoroughfare: "READING BRIDGE",
        DoubleDependentLocality: "",
        DependentLocality: "",
        PostTown: "READING",
        Postcode: "RG1 8LS"
      }
    ],
    postcodeLists: [
      {
        text:
          "Postcode value is mandatory. Postcode should be valid otherwise its throws an error Postcode does not exist."
      },
      {
        text:
          "Postcode value can contain single (*) wildcard character.(E.g. RG1*Ls)"
      },
      {
        text:
          "Double wildcard character not allowed in postcode. (E.g. RG1**s , R*L1*s)"
      }
    ],
    otherLists: [
      {
        text:
          "Every filed in output is separated by | and if number of lines are in the output then it is separated by “,”."
      },
      {
        text: "If any field value is empty then output looks like ||."
      },
      {
        text:
          "When “serialised” parameter value is false, then it returns output in below format –"
      }
    ],
    orderNumber: 5
  })
};
</script>
